var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.0642L5.45258 7.24431L4.18743 5.69531L0 9.11541V22.9998H23V9.11541L18.8126 5.69531L17.5474 7.24431L21 10.0642V20.9998H2V10.0642Z",
    fill: "#7F5FEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.410156 11.3487L1.58687 9.73145L11.4985 16.9433L21.4102 9.73145L22.5869 11.3487L11.4985 19.4167L0.410156 11.3487Z",
    fill: "#7F5FEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82031 0H19.1803V13.41H17.1803V2H5.82031V13.41H3.82031V0Z",
    fill: "#7F5FEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3197 5.82031H7.67969V3.82031H15.3197V5.82031Z",
    fill: "#7F5FEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3197 9.63965H7.67969V7.63965H15.3197V9.63965Z",
    fill: "#7F5FEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3197 13.4502H7.67969V11.4502H15.3197V13.4502Z",
    fill: "#7F5FEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c4f4e0556d0babcca9f6bfa077840221.svg";
export { ForwardRef as ReactComponent };